'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _genericMaterials = require('../actions/genericMaterials');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchGenericMaterials),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchGenericMaterial),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editGenericMaterial),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createGenericMaterial),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchGenericMaterialsRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchGenericMaterialRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(editGenericMaterialRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(createGenericMaterialRequest);

function fetchGenericMaterials(_ref) {
    var objectiveId = _ref.objectiveId;
    var url, response, genericMaterials;
    return regeneratorRuntime.wrap(function fetchGenericMaterials$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    url = '/genericmaterials';


                    if (objectiveId !== undefined && objectiveId !== null) {
                        url = url + '?objectiveId=' + objectiveId;
                    }

                    _context.next = 5;
                    return (0, _effects.call)(_api.request, 'get', url);

                case 5:
                    response = _context.sent;
                    genericMaterials = response.data.sort(function (a, b) {

                        if (a.name < b.name) {
                            return -1;
                        }
                        return 1;
                    });
                    _context.next = 9;
                    return (0, _effects.put)(_genericMaterials.actionCreators.fetchGenericMaterialsSucceeded(genericMaterials));

                case 9:
                    _context.next = 15;
                    break;

                case 11:
                    _context.prev = 11;
                    _context.t0 = _context['catch'](0);
                    _context.next = 15;
                    return (0, _effects.put)(_genericMaterials.actionCreators.fetchGenericMaterialsFailed(_context.t0));

                case 15:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 11]]);
}

function fetchGenericMaterial(_ref2) {
    var id = _ref2.id;
    var response, genericMaterial;
    return regeneratorRuntime.wrap(function fetchGenericMaterial$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/genericmaterials/' + id);

                case 3:
                    response = _context2.sent;
                    genericMaterial = response.data;
                    _context2.next = 7;
                    return (0, _effects.put)(_genericMaterials.actionCreators.fetchGenericMaterialSucceeded(genericMaterial));

                case 7:
                    _context2.next = 13;
                    break;

                case 9:
                    _context2.prev = 9;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 13;
                    return (0, _effects.put)(_genericMaterials.actionCreators.fetchGenericMaterialFailed(_context2.t0));

                case 13:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 9]]);
}

function editGenericMaterial(_ref3) {
    var genericMaterial = _ref3.genericMaterial;
    var response;
    return regeneratorRuntime.wrap(function editGenericMaterial$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/genericmaterials/' + genericMaterial.id, genericMaterial);

                case 3:
                    response = _context3.sent;
                    _context3.next = 6;
                    return (0, _effects.put)(_genericMaterials.actionCreators.editGenericMaterialSucceeded(response.data));

                case 6:
                    _context3.next = 12;
                    break;

                case 8:
                    _context3.prev = 8;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 12;
                    return (0, _effects.put)(_genericMaterials.actionCreators.createGenericMaterialFailed(_context3.t0.response ? _context3.t0.response.data : _context3.t0));

                case 12:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 8]]);
}

function createGenericMaterial(_ref4) {
    var genericMaterial = _ref4.genericMaterial;
    var response;
    return regeneratorRuntime.wrap(function createGenericMaterial$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/genericmaterials/', genericMaterial);

                case 3:
                    response = _context4.sent;
                    _context4.next = 6;
                    return (0, _effects.put)(_genericMaterials.actionCreators.createGenericMaterialSucceeded(response.data));

                case 6:
                    _context4.next = 12;
                    break;

                case 8:
                    _context4.prev = 8;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 12;
                    return (0, _effects.put)(_genericMaterials.actionCreators.createGenericMaterialFailed(_context4.t0.response ? _context4.t0.response.data : _context4.t0));

                case 12:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 8]]);
}

function fetchGenericMaterialsRequest() {
    return regeneratorRuntime.wrap(function fetchGenericMaterialsRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_genericMaterials.actionTypes.FETCH_GENERIC_MATERIALS_REQUEST, fetchGenericMaterials);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function fetchGenericMaterialRequest() {
    return regeneratorRuntime.wrap(function fetchGenericMaterialRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_genericMaterials.actionTypes.FETCH_GENERIC_MATERIAL_REQUEST, fetchGenericMaterial);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function editGenericMaterialRequest() {
    return regeneratorRuntime.wrap(function editGenericMaterialRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_genericMaterials.actionTypes.EDIT_GENERIC_MATERIAL_REQUEST, editGenericMaterial);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function createGenericMaterialRequest() {
    return regeneratorRuntime.wrap(function createGenericMaterialRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_genericMaterials.actionTypes.CREATE_GENERIC_MATERIAL_REQUEST, createGenericMaterial);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

exports.default = [fetchGenericMaterialsRequest, fetchGenericMaterialRequest, editGenericMaterialRequest, createGenericMaterialRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/genericMaterials.js
// module id = 2238
// module chunks = 0